import React from 'react';
import { Trash2 } from 'react-feather';
import { User } from '../global-components/src/types';
import { useTranslation } from 'react-i18next';

interface RemovePictureProfileProps {
    user: User | undefined;
    can_remove_photo: boolean;
    onDelete: () => void; // Adicionado
}

const RemovePictureProfile: React.FC<RemovePictureProfileProps> = ({ user, onDelete, can_remove_photo }) => {
    const { t } = useTranslation();
    return (
        <>
            {can_remove_photo && user?.img_account ? (
                <li>
                    <ul className="ul-normal">
                        <span onClick={onDelete} className="dropdown-item cursor-pointer user-select-none">
                            <div className="div-icon-fix">
                                <><Trash2 data-feather="paperclip" data-type="unfix" className="icon-config-post"/>{t("account.removeProfilePhoto")}</>
                            </div>
                        </span>
                    </ul>
                </li>
            ) : null}
        </>
    );
};

export default RemovePictureProfile;
